const choices = {
    executive: 'Cadre',
    nonExecutive: 'Non cadre',
};

export default choices;
